(function () {
  'use strict'

  /**
     * @ngdoc directive
     * @name ThismomentBackgroundImage
     * @module thismoment.common.directive.backgroundImage
     *
     * @param {scope} scope
     * @param {Element} element the html element to add the background to
     * @param {object} attrs an object of attributes about the element
     *
     * @description
     * A directive that makes an image the background of an html element
     */

  var MODULE_NAME = 'thismoment.common.directive.backgroundImage'

  angular
    .module(MODULE_NAME, [])
    .directive('backgroundImage', backgroundImage)

  function backgroundImage () {
    return function (scope, element, attrs) {
      if (!attrs.backgroundImage) { return }
      element.css({
        'background-image': 'url(' + attrs.backgroundImage + ')',
        'background-size': 'contain',
        'background-repeat': 'no-repeat'
      })
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/common/directive/background-image.js